import { useEffect, useRef, useState } from 'react'
import { useMeetingStore } from '../../store/meeting.store'
import { Box, Typography, useTheme } from '@mui/material'
import { observer } from 'mobx-react'
import DataLoadingSpinner from '../common/DataLoadingSpinner'

const VideoPreview = observer( ( { styles = {}, track, width = "100%", height = "auto" } ) => {
    const videoPreviewContainer = useRef()
    const [loading, setLoading] = useState( true )

    const { palette } = useTheme()

    useEffect( () => {
        let localClone
        let timer

        if ( track && videoPreviewContainer.current ) {
            timer = setTimeout( () => {
                localClone = track.clone()
                localClone.play( videoPreviewContainer.current )
                setLoading( false )
            }, 2000 ) // small delay to let track initialize
        }

        return () => {
            clearTimeout( timer )
            if ( localClone ) {
                localClone.stop()
                localClone.close()
            }
        }
    }, [track] )

    return (
        <Box height={height} flexShrink={0} width={width} margin="1px auto" sx={{ position: "relative", backgroundColor: "#000", borderRadius: "20px", overflow: "hidden" }} position="relative">

            {loading && <Box position="absolute" display="flex" alignItems="center" justifyContent="center" sx={{ inset: 0 }} zIndex={10} bgcolor={palette.grey[800]} >
                <DataLoadingSpinner styles={{ color: palette.common.white }} waitingMessage='Loading...' />
            </Box>}
            <Box
                ref={videoPreviewContainer}
                component="video"
                height="100%" width="100%"
                hidden={loading}
                sx={{ objectFit: "cove", ...styles }}
            />
        </Box>
    )
} )

export default VideoPreview
